
import { defineComponent, computed, ref, onBeforeUnmount } from 'vue'
import AppHeader from '@/components/Header.vue'
import DeviceFooter from '@/components/device/Footer.vue'
import { Field, Uploader, Dialog } from 'vant'
import { DeviceItem } from '@/types/device'
import getCacheFaultBillInfo from '@/compositions/fault/device'
import getCacheUserAddressInfo from '@/compositions/userAddress'
import uploadFilesSetup from '@/compositions/uploadFiles'
import { LogItem, CacheFaultBill, SubmitFaultBill } from '@/types/fault'
import { ImageInfo, UploadFile } from '@/types/public'
import { copy } from '@/utils/index'
import { useStore } from 'vuex'
import { SaveFaultBill } from '@/apis/fault'
import { ComponentInstance } from 'vant/lib/utils'

export default defineComponent({
  name: 'Fault-Form',
  components: {
    AppHeader,
    DeviceFooter,
    VanField: Field,
    VanUploader: Uploader,
  },
  setup() {
    const {
      cacheFaultBill,
      cacheFaultDevices,
      cacheCompleteDevices,
      cacheComponents,
      isHasFullInsurance,
      cacheNetworkpoint,
      cacheDescribe,
      cacheImgs,
      receiveExpress,
      setReceiveAddress,
    } = getCacheFaultBillInfo()
    const { userAddressInfo, isDefault } = getCacheUserAddressInfo()
    const setAddress = () => {
      if (isDefault.value) {
        setReceiveAddress(userAddressInfo.value)
      }
    }
    setAddress()
    const { uploadFiles, getFiles } = uploadFilesSetup()
    let _ts: number = Date.now()
    let describe: { value: string } = ref(cacheDescribe.value)
    const fileList = ref(cacheImgs.value)
    const store = useStore()
    const describeLen = computed((): number => describe.value.length)
    const fLen = computed((): number => fileList.value.length)
    const cacheNetworkpointName = computed(() => cacheNetworkpoint.value?.name || '')
    const receiver = computed(() => {
      return receiveExpress.value?.name || ''
    })
    const phone = computed(() => {
      return receiveExpress.value?.phone || ''
    })
    const address = computed(() => {
      const { province, city, area, address } = receiveExpress.value || {
        province: '',
        city: '',
        area: '',
        address: '',
      }
      let beforeAddress = ''
      if (province === city) {
        beforeAddress += province
      } else {
        beforeAddress += `${province}${city}`
      }
      return `${beforeAddress}${area}${address}`
    })
    const noHasAddress = computed(() => {
      return !receiver.value && !phone.value && !address.value
    })
    const isCanClick = computed(
      () =>
        !!(
          (cacheCompleteDevices.value.length || cacheComponents.value.length) &&
          cacheNetworkpoint.value
        )
    )
    onBeforeUnmount(() => {
      _ts = 0
    })
    return {
      isCanClick,
      describe,
      describeLen,
      cacheFaultBill,
      cacheFaultDevices,
      cacheCompleteDevices,
      cacheComponents,
      isHasFullInsurance,
      cacheNetworkpoint,
      fileList,
      cacheNetworkpointName,
      fLen,
      $store: store,
      uploadFiles,
      getFiles,
      _ts,
      receiver,
      noHasAddress,
      phone,
      address,
    }
  },
  methods: {
    afterRead(files: UploadFile[] | UploadFile): void {
      files = Array.isArray(files) ? files : [files]
      files.forEach((it) => {
        it.status = 'uploading'
        it.message = '上传中...'
      })
      this.uploadFiles(files).then((data) => {
        if (data?.fileStrArr?.length) {
          const { fileStrArr, files } = data
          this.getFiles(files, fileStrArr).then((res) => {
            if (res?.fileObjArr?.length) {
              const { fileObjArr, files } = res
              this.onSetImages(fileObjArr, files)
            }
          })
        }
      })
    },
    beforeDelete(file: ImageInfo | UploadFile) {
      const cacheFaultBill: CacheFaultBill = copy(this.cacheFaultBill)
      let imgs: ImageInfo[] = cacheFaultBill?.imgs || []
      cacheFaultBill.imgs = imgs.filter((it) => it.uid !== file.uid)
      this.$store.commit('setFaultBill', cacheFaultBill)
      return true
    },
    onSetImages(iamges: ImageInfo[], files: UploadFile[]): void {
      files.forEach((it) => {
        it.status = 'done'
        it.message = '上传完成'
      })
      const cacheFaultBill: CacheFaultBill = copy(this.cacheFaultBill)
      if (cacheFaultBill) {
        let imgs: ImageInfo[] = cacheFaultBill?.imgs || []
        imgs = imgs.filter((item) => !iamges.some((it) => item.uid === it.uid))
        // console.log('imgs', imgs, cacheFaultBill)
        cacheFaultBill.imgs = [...imgs, ...iamges]
        const fileList: UploadFile[] | ImageInfo[] = this.fileList.filter(
          (it: UploadFile | ImageInfo): boolean => !it?.uid
        )
        fileList.forEach((it, i) => {
          it.uid = iamges[i].uid
        })
        this.$store.commit('setFaultBill', cacheFaultBill)
      }
    },
    onToLogs(item: DeviceItem): void {
      if (!item?.serial_number) return
      this.$router.push({ name: 'fault-journal', params: { sn: item.serial_number } })
    },
    onViewDevices(): void {
      this.$router.push({ name: 'fault-devices' })
    },
    onFillVoucher(item: DeviceItem): void {
      if (!item?.serial_number) return
      this.$router.push({ name: 'fault-voucher', params: { sn: item.serial_number } })
    },
    onToSetPoint(): void {
      this.$router.push({ name: 'fault-networkpoints' })
    },
    onToSetAdress(): void {
      this.$router.push({ name: 'fault-address' })
    },
    onDelLog(logItem: LogItem): void {
      const masterDevices: DeviceItem[] = copy(this.cacheCompleteDevices || [])
      const firstMasterDevice: DeviceItem = masterDevices[0]
      const cacheFaultBill: CacheFaultBill = copy(this.cacheFaultBill)
      firstMasterDevice.logs = firstMasterDevice.logs.filter((it) => it.guid !== logItem.guid)
      cacheFaultBill.devices = [...this.cacheComponents, firstMasterDevice]
      this.$store.commit('setFaultBill', cacheFaultBill)
    },
    onSetDescribe(val: string): void {
      const cacheFaultBill: CacheFaultBill = copy(this.cacheFaultBill)
      cacheFaultBill.describe = val
      this.$store.commit('setFaultBill', cacheFaultBill)
    },
    onSubmitForm(): void {
      if (!this.isCanClick) {
        this.$toast('设备和维修网点信息都必须存在')
        return
      }
      if (this.fLen > 9) {
        this.$toast('设备故障照片不能大于9张')
        return
      }
      if (this.describeLen > 200) {
        this.$toast('故障不能大于200字')
        return
      }
      Dialog.confirm({
        className: 'fault-module',
        title: '确定提交？',
        message: '网点接单后，为了检测和维修设备，设备使用权会发生变更。',
      }).then(async () => {
        const toast: ComponentInstance = this.$toast.loading({
          message: '提交中...',
          forbidClick: true,
          duration: 0,
        })
        const ts = this._ts
        try {
          const arr: SubmitFaultBill[] = this.getSubmitParams()
          // if (!arr?.length) {
          //   toast.clear()
          //   return
          // }
          await SaveFaultBill(arr)
          if (ts !== this._ts) return
          this.$router.replace({ name: 'fault-savebillsuccess' })
          toast.clear()
        } catch (err: unknown) {
          if (ts !== this._ts) return
          toast.clear()
          const message: string = (err as { message: string }).message
          this.$toast(message)
          console.error(message)
        }
      })
    },
    getSubmitParams(): SubmitFaultBill[] {
      const { devices, imgs, networkpoint, describe, receiveExpress } = this.cacheFaultBill
      const arr: SubmitFaultBill[] = []
      const lng = 0
      const lat = 0
      devices.forEach((it: DeviceItem) => {
        const obj: SubmitFaultBill = {
          process_type: it.type === 1 ? 'P_SERIAL' : 'EQ_OTHER',
          serial_number: it.serial_number,
          lat,
          lng,
          repair_warehouse_guid: networkpoint?.guid || '',
          repair_warehouse_type: networkpoint?.type || '',
          description: describe || '',
        }
        Object.assign(obj, {
          images: Array.isArray(imgs) ? imgs.map((item: ImageInfo) => item.uid) : [],
        })
        const { logs, imgs: images, describe: voucher } = it

        Object.assign(obj, {
          logs: it.type === 1 && Array.isArray(logs) ? logs.map((item: LogItem) => item.guid) : [],
        })
        Object.assign(obj, {
          receive_express: receiveExpress,
        })
        Object.assign(obj, {
          certificate: {
            description: it.type !== 1 && voucher ? voucher : '',
            images:
              it.type !== 1 && Array.isArray(images)
                ? images.map((item: ImageInfo) => item.uid)
                : [],
          },
        })
        arr.push(obj)
      })
      return arr
    },
  },
})
